$(document).ready(function () {
  const triggerModal = (clickedSlide) => {
    clickedSlide.classList.add("active");
    const modal = document.getElementById(clickedSlide.dataset.modalId);
    if (modal) {
      modal.classList.add("active");
      modal.addEventListener("click", (event) => {
        if (
          !event.target.closest(".features-slider-modal__close") &&
          event.target.closest(".features-slider-modal__card")
        )
          return;

        modal.classList.remove("active");
        clickedSlide.classList.remove("active");
      });
    }
  };

  const container = document.querySelector(
    ".features-slider .features-slider-items.swiper-container",
  );
  const slideCount = container
    ? container.querySelectorAll(".swiper-slide").length
    : 0;
  const maxSlidesPerView = 6;
  const hasEnoughSlides = slideCount > maxSlidesPerView;

  // Shared state read by the setTranslate hook
  let isFitted = false;

  const swiper = new Swiper(
    ".features-slider .features-slider-items.swiper-container",
    {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: hasEnoughSlides,
      pagination: {
        el: ".features-slider .swiper-pagination",
        clickable: true,
      },
      allowTouchMove: true,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        900: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
        1200: {
          slidesPerView: 5,
        },
        1440: {
          slidesPerView: 6,
          spaceBetween: 30,
        },
        1920: {
          slidesPerView: 6,
          spaceBetween: 30
        }
      },
      on: {
        click: function (swiper, event) {
          const clickedSlide = event.target.closest(".swiper-slide");
          if (!clickedSlide) return;

          triggerModal(clickedSlide);
        },
        // Intercept every translate Swiper sets and override with centering when all slides fit.
        // This avoids touching justify-content on the wrapper, which corrupts Swiper's snap grid.
        setTranslate: function (swiper) {
          if (!isFitted) return;
          const wrapper = swiper.wrapperEl;
          const firstSlide = wrapper && wrapper.querySelector(".swiper-slide");
          if (!firstSlide) return;
          const gap = swiper.params.spaceBetween || 0;
          const totalW = slideCount * firstSlide.offsetWidth + (slideCount - 1) * gap;
          const offset = Math.max(0, Math.round((container.clientWidth - totalW) / 2));
          wrapper.style.transform = `translate3d(${offset}px, 0, 0)`;
        },
      },
    },
  );

  if (container) {
    function getActiveSlidesPerView() {
      const w = window.innerWidth;
      if (w >= 1440) return 6;
      if (w >= 1200) return 5;
      if (w >= 1024) return 4;
      if (w >= 900) return 3;
      if (w >= 768) return 2;
      return 1;
    }

    function updateAlignment() {
      const fits = slideCount <= getActiveSlidesPerView();
      isFitted = !hasEnoughSlides && fits;

      if (!hasEnoughSlides) {
        if (fits) {
          container.classList.add("features-slider-items--no-peek");
          swiper.allowTouchMove = false;
        } else {
          container.classList.remove("features-slider-items--no-peek");
          swiper.allowTouchMove = true;
        }
        swiper.update();
      }

      const pagination = container.parentElement.querySelector(".swiper-pagination");
      if (pagination) {
        pagination.style.display = (hasEnoughSlides || !fits) ? "block" : "none";
      }
    }

    swiper.on("breakpoint", updateAlignment);
    swiper.on("resize", updateAlignment);
    updateAlignment();
  }
});
